import Vue from 'vue';
import * as Sentry from '@sentry/vue';

function getMetaContentByProperty(property) {
  const metaTag = document.querySelector(`meta[property='${property}']`);
  return metaTag ? metaTag.content : null;
}
const GlobalSentry = Sentry.init({
  Vue,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.NODE_ENV || 'development',
  integrations: [
    Sentry.browserTracingIntegration(), // 追踪前端性能，如页面加载时间、API 请求耗时等
    Sentry.replayIntegration(), // 记录用户操作，如点击、输入等，帮助回溯问题
    Sentry.rewriteFramesIntegration({
      // 使用 rewriteFramesIntegration
      iteratee: (frame) => {
        // 修改路径以匹配上传的工件
        frame.filename = frame.filename.replace(process.env.PUBLIC_PATH, '/');
        return frame;
      },
    }),
  ],
  // Tracing
  // tracePropagationTargets: [
  //   'localhost',
  //   /:3000\/.*/,
  //   /:63423\/.*/,
  //   /^https:\/\/[^\/]+\.xd\.cn(\/.*)?$/,
  //   /^https:\/\/[^\/]+\.xd\.com(\/.*)?$/,
  //   /^https:\/\/[^\/]+\.taptap\.cn(\/.*)?$/,
  //   /^https:\/\/[^\/]+\.taptap\.com(\/.*)?$/,
  //   /^https:\/\/[^\/]+\.taptap\.io(\/.*)?$/,
  // ],
  tracesSampleRate: 1.0, // 设置追踪采样率
  // replaysSessionSampleRate: 0, // 关闭录屏
  // replaysOnErrorSampleRate: 0, // 关闭错误发生时的录屏
  // autoSessionTracking: false, // 禁用自动会话跟踪
  initialScope: (scope) => {
    const siteName = getMetaContentByProperty('og:site_name');
    // 设置标签
    scope.setTag('app_id', window.moo.app_id); // 游戏ID
    scope.setTag('site_name', siteName); // 站点名称
    scope.setTag('title', document.title); // 页面标题
    scope.setTag(
      'transaction',
      `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    ); // 完整网址
    return scope;
  },
  release: process.env.SENTRY_RELEASE_VERSION,
});

Vue.prototype.$sentry = GlobalSentry;
